import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9993 9.2496L30.0001 0L46.0009 9.2496L40.0009 12.4992L30.0001 6.7488L19.7497 12.4992L13.9993 9.2496ZM45.7489 20.7504L39.9985 17.5008L30.0001 23.2512L19.7497 17.5008L13.9993 20.7504V27.5016L24.0001 33.252V45.0024L29.7505 48.5016L35.5009 45.0024V33.5016L45.5017 27.7512V20.7504H45.7489ZM45.7489 39.2496V32.5008L40.0009 36V42.4992L45.7489 39.2496ZM49.9993 41.5008L39.9985 47.2512V54L55.9993 44.7504V26.2512L49.9993 30V41.5008ZM44.2513 15L50.0017 18.4992V25.2504L55.7521 21.7512V15L50.0017 11.5008L44.2513 15ZM24.0001 49.7496V56.4984L29.7505 59.9976L35.5009 56.4984V49.7496L29.7505 53.2488L24.0001 49.7496ZM13.9993 39.2496L19.7497 42.4992V35.7504L13.9993 32.2512V39.2496ZM24.0001 15L29.7505 18.4992L35.7505 15L30.0001 11.5008L24.0001 15ZM9.74894 18.4992L15.7489 15L9.74894 11.5008L4.00093 15V21.7488L9.75133 25.248V18.4992H9.74894ZM9.74894 30L3.99854 26.5008V45L19.9993 54.2496V47.5008L9.99854 41.7504V30H9.74894Z"
      fill="#ECEDEE"
    />
  </svg>
)
